import $ from 'jquery';
import DataTable from 'datatables.net-dt';

const $window = $(window);
const $header = $('.site-header');
const $dealer_table = $('#dealer-table');
const $dealer_table_wrapper = $('.table-wrapper');
const $dealer_cart = $('#dealer-cart');
const $search = $('#dealer-table_filter input');
const $search_clear = $('<span id="clearSearch" class="clear-search">×</span>').insertAfter($search);

const dataTable = $dealer_table.DataTable({
    ajax: {url: '/?wc-ajax=product_table', dataSrc: ''},
    deferRender: true,
    paging: true,
    pageLength: 25,
    columns: [
        {data: 'name', searchable: true, className: 'product-title'},
        {data: 'sku', searchable: true, className: 'product-sku'},
        {data: {_: 'price', display: 'price_html'}, searchable: false, className: 'product-price'},
        {searchable: false, orderable: false, className: 'product-quantity', defaultContent: '<div class="input-container quantity-wrap"><button class="quantity-stepper quantity-stepper--decrease" type="button" data-increment="-1" aria-hidden="true"></button><input type="number" class="product-quantity-value" min="1" value="1" /><button class="quantity-stepper quantity-stepper--increase" type="button" data-increment="1" aria-hidden="true"></button></div>'},
        {data: 'button', searchable: false, orderable: false, className: 'add-to-cart-button'},
    ],
});

$dealer_table.on('click', '.add_to_cart_button', e => {
    const $this = $(e.currentTarget);
    $this.parent().addClass('btn-animation');
});

$dealer_table.on('click', '.quantity-stepper--decrease, .quantity-stepper--increase', e => {
    const $this = $(e.currentTarget);
    const quantity = $this.parent().find('input');
    let current_value = parseInt(quantity.val());

    if ($this.hasClass('quantity-stepper--decrease')) {
        if (current_value > 1) {
            quantity.attr('value', current_value - 1);
        }
    } else if ($this.hasClass('quantity-stepper--increase')) {
        quantity.attr('value', current_value + 1);
    }
    $this.closest('tr').find('.add_to_cart_button').attr('data-quantity', quantity.val());
});

$(document.body).on('added_to_cart', (e, fragments, cart_hash, $button) => {
    $button.closest('tr').find('.product-quantity-value').val(1);
});

$dealer_table.on('change', '.product-quantity-value', e => {
    const $this = $(e.currentTarget);
    $this.closest('tr').find('.add_to_cart_button').attr('data-quantity', $this.val());
});

$search_clear.on('click', e => {
    const $this = $(e.currentTarget);
    dataTable.search('').draw();
    $this.removeClass('show-x');
});

$search.on('change keyup', e => {
    const $this = $(e.currentTarget);
    $search_clear.toggleClass('show-x', $this.val() !== '');
});

function removeBtnAnimation() {
    $('.btn-animation').removeClass('btn-animation');
}

$(document).on('click', '.paginate_button', removeBtnAnimation);
$(window).on('resize', removeBtnAnimation);

$window.on('load scroll resize', () => {
    if ($dealer_table.length && $window.outerWidth() > 1024) {
        let scrollPos = $window.scrollTop();
        let header_height = $header.height() - 20;
        let elementPos = $dealer_table.offset().top - header_height;
        let bottom_pos = $dealer_table_wrapper.height() - $dealer_cart.height() - 20;

        if (scrollPos - elementPos >= bottom_pos) {
            $dealer_cart.css('top', bottom_pos);
        } else if (scrollPos >= elementPos) {
            $dealer_cart.css('top', scrollPos - elementPos);
        } else {
            $dealer_cart.css('top', 0);
        }
    } else {
        $dealer_cart.css('top', 0);
    }
});
